import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import Condition from "../../../components/Conditional/Condition";
import I18nText from "../../../components/I18nText/I18nText";
import { useCartContext } from "../../../contexts/CartServiceContext/CartServiceContext";
import { useConfigContext } from "../../../contexts/ConfigContext/ConfigContext";
import ClearAll from "../ClearAllButton/ClearAll";
import DineInTakeawayButton from "./DineInTakeawayButton";

const CartHeader = (): ReactElement => {
	const { t } = useTranslation();
	const { state: cart } = useCartContext((state) => state.cart);
	const { state: allow_takeaway } = useConfigContext((state) => state.config.allow_takeaway);

	return (
		<div className="CartHeader">
			<span className="MyOrder">
				<I18nText
					className="MyOrderTitle"
					enText={t("cartPage.title")}
					cnText={t("cartPage.title")}
				/>
			</span>
			<Condition check={!!allow_takeaway}>
				<DineInTakeawayButton />
			</Condition>
			<Condition check={cart.length !== 0}>
				<span className="ClearAll">
					<ClearAll />
				</span>
			</Condition>
		</div>
	);
};

export default CartHeader;
